export enum ContentType {
    FAQ = 'FAQ',
    TAC = 'TAC',
    DPP = "DPP",
    CSY = "CSY"
}
